import { FarmLocation } from "@abaco/farm-registry/src/modules/farm-registry/models/Farm";
import { HTTPClient, propsToDate, propsToDatePaged } from "@abaco/web-common/src/HTTP";
import { dbGIStoStandardPage, PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import { WorkShift, SubjectWorker } from "../models/WorkShift";

export default class WorkShiftApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getWorkShifts(pkCuaa: number, from?: number, to?: number, worker_id?: number): Promise<WorkShift[]> {
        const filtersValues = [];
        if (worker_id) {
            filtersValues.push(`worker_id eq ${worker_id}`)
        }
        let dateFilter = "?1=1";
        if(from){
            dateFilter = dateFilter + `&from=${from}`
        }
        if(to){
            dateFilter = dateFilter + `&to=${to}`
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/workers/dashboard/subjects/${pkCuaa}/work_shifts${dateFilter}`, {
            params: {
                filter: filtersValues
            }
        });
        return res.data;
    }

    public async getWorkers(pkCuaa: number, filter: string, paging: PagingParams): Promise<PagedResults<SubjectWorker>> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/dictionary_workers`, {
            params: {
                filter: filter ? `^subject_full_name like ${filter.toUpperCase()}` : undefined,
                offset: paging.offset,
                count: paging.count,
            }
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        //res.data.records = res.data.records.map((r: any) => ({ pk_cuaa: r.subject_id, cuaa: r.company_code, description: r.full_name }))
        return res.data;
    }

    public async getFarmLocation(pkCuaa: number): Promise<FarmLocation> {
        const res = await this.http.get("/siticatasto/dbgis-servlet/rest_tl_data", {
            params: {
                svccode: "portal/get_farm_location",
                pk_cuaa: pkCuaa
            }
        });

        const ret = dbGIStoStandardPage<FarmLocation>(res.data, 25).records[0];
        return ret;
    }

}
